<script setup lang="ts">
import SectionAccount from '@sections/section-account.vue';
import PartPaymentHistory from '@parts/part-payment-history.vue';

import {computed, onBeforeMount, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useBillingApi} from "@store/api/billingApi";
import {Bill} from "@store/api/interfaces";
import CoreLoader from "@core/core-loader.vue";
import ButtonPrimary from '@buttons/button-primary.vue';
import PartFooterNavigation from '@parts/part-footer-navigation.vue';

const {t} = useI18n();
const isLoading = ref<boolean>(false);

const fields = computed(() => {
	return {
		title: t('accountHistory.title'),
		subtitle: isEmptyBills.value ? t('accountHistory.emptyBillsMessage'): '',
		icon: '/images/history-icon.svg',
		backButton: {
			title: t('common.buttons.back'),
			url: "/account"
		},
		payButton: {
			title: t('accountHistory.paymentButton'),
			url: "/payment"
		}
	}
});

const billingService = useBillingApi();
const bills = ref<Bill[]>([]);

const isEmptyBills = computed(() => {
	return bills.value.length === 0 && !isLoading.value;
})

onBeforeMount(async () => {
	isLoading.value = true;
	// Невыставленные счета — не история: человек их не оплачивал, а строка
	// «счёт выставлен, но не оплачен» читается как долг
	bills.value = (await billingService.http.getList()).filter(bill => bill.status !== 'created');
	isLoading.value = false;
});
</script>

<template>
<main class="page page-history">
	<transition
		appear
		name="fade"
		style="--animation-delay: 0s;"
	>
		<section-account
			:fields="fields"
		>
			<transition
				v-if="!isLoading"
				appear
				name="fade"
				style="--animation-delay: 0.3s"
			>
				<part-payment-history
					v-if="bills.length > 0"
					:list="bills"
					class="page-history__list"
				/>
			</transition>
			<transition
				v-else
				appear
				name="show-up"
				style="--animation-delay: 0.3s"
			>
				<core-loader
					:title="t('common.loader.history_payment')"
				/>
			</transition>

			<part-footer-navigation
				v-if="fields?.backButton && !isLoading"
				fixed
			>
				<button-primary
					v-if="isEmptyBills"
					class="page-history__back"
					:to="fields.payButton.url"
				>
					{{ fields.payButton.title }}
				</button-primary>

				<button-primary
					v-else
					pink
					class="page-history__back"
					:to="fields.backButton.url"
				>
					{{ fields.backButton.title }}
				</button-primary>
			</part-footer-navigation>
		</section-account>
	</transition>
</main>
</template>

<style lang="scss">
.page-history {
  &__list {
    margin-bottom: 1.6rem;
	@include min-desktop {
		margin-bottom: 6.4rem;
	}
  }
}
</style>
